<template>
    <card title="" :isFullPage="true">
        <data-table entity-name="report" entity-name-plural="reports" :columns="columns" :rows="rows"
            :total-row-count="totalRowCount" selection-key="id" :action-in-progress="actionsInProgress > 0"
            @queryChanged="onQueryChanged">

            <template v-slot:actions="props">
                <export-action v-bind="props" export-resource="device-links"></export-action>
                <delete-action v-if="isSuperUser || isStaffUser || isPartner || isManager" v-bind="props" @deleteAction="onDelete"></delete-action>
                <print-action v-bind="props" @printAction="onPrint"></print-action>
            </template>
        </data-table>
    </card>
</template>
<script>
import { mapGetters } from 'vuex';
import { notify } from '../services/notify';

import api from '../services/api';
import print from '../components/DataTable/print';
import DataTable from '../components/DataTable/DataTable.vue';
import DeleteAction from '../components/DataTable/Actions/DeleteAction.vue';
import ExportAction from '../components/DataTable/Actions/ExportAction.vue';
import ImportAction from '../components/DataTable/Actions/ImportAction.vue';
import PrintAction from '../components/DataTable/Actions/PrintAction.vue';

export default {
    name: 'DeviceLinks',
    components: {
        DataTable,
        DeleteAction,
        ExportAction,
        ImportAction,
        PrintAction,
    },
    data() {
        return {
            columns: [],
            baseColumns: [
                { key: 'details', type: 'action', action: this.viewDeviceLink, actionIcon: 'hdd', visible: true },
                { key: 'created_at', type: 'datetime', visible: true },
                { key: 'created_by' },
                { key: 'report.station', label: 'Station ID', visible: false},
                { key: 'report.device_class', label: 'Device class', visible: true, type: 'category',
                categories: [
                    'Chromebook',
                    'Chromebook Audit and Test',
                    'MacBook',
                ]},
                { key: 'report.session.vendor', label: 'Vendor', visible: true},
                { key: 'report.session.model', label: 'Model', visible: true},
                { key: 'report.session.serial', label: 'Serial', visible: true},
                { key: 'report.session.state', label: 'State', visible: false},
                { key: 'report.session.disk_erasure_result', label: 'Erasure Result', visible: false},
            ],
            rows: [],
            totalRowCount: 0,
            lastQuery: null,
            actionsInProgress: 0,
            savedTableName: null,
        }
    },
    async created() {
        await this.$store.cache.dispatch('user/fetchMe');
        if (this.isSuperUser || this.isStaffUser || this.isPartner) {
            this.columns = [{ key: 'organization.name', label: 'Organization', visible: true }, { key: 'group.name', label: 'Group', visible: true }, ...this.baseColumns];
        }
        else if (this.isManager) {
            this.columns = [{ key: 'group.name', label: 'Group', visible: true }, ...this.baseColumns];
        }
        else {
            this.columns = this.baseColumns;
        }
    },
    methods: {
        async refreshQuery() {
            if (this.lastQuery !== null) {
                await this.onQueryChanged(this.lastQuery);
            }
        },
        async onQueryChanged(query) {
            this.lastQuery = query;
            try {
                const response = await api.getWithParams('/device-links/', query);
                this.rows = response.data.data;
                this.totalRowCount = response.data.pagination.count;
            }
            catch(err) {
                this.rows = [];
                this.totalRowCount = 0;
                notify().error('Error fetching reports.');
            }
        },
        async onDelete(selectOrFilter) {
            this.actionsInProgress++;
            try {
                const response = await api.delete('/device-links/', selectOrFilter);
                await this.refreshQuery();
            }
            catch(err) {
                notify().error('Error deleting reports.');
            }
            finally {
                this.actionsInProgress--;
            }
        },
        async onPrint(selectOrFilter, rowConverter) {
            this.actionsInProgress++;
            try {
                const response = await api.postJSON('/device-links/select', selectOrFilter);
                const rows = response.data;
                await print.pdf(rowConverter(rows));
            }
            catch(err) {
                notify().error('Error printing a report.');
                throw err;
            }
            finally {
                this.actionsInProgress--;
            }
        },
        async viewDeviceLink(row) {
            this.$router.push(`/device-link/reports/${row.id}`);
        },
    },
    computed: {
        ...mapGetters('user', ['isSuperUser', 'isStaffUser', 'isPartner', 'isManager']),
    },
}
</script>
